export default __webpack_public_path__ + "static/media/amhSanta.d9a9c807.svg";